import React from "react";
import AliceCarousel from "react-alice-carousel";
import ReviewsFromInternetItem from "./review-internet-item";
import "react-alice-carousel/lib/alice-carousel.css";
import { useTranslation } from "react-i18next";

import { StyledReviewsInternet } from "./styled-reviews";

import bestchange from "../../assets/images/reviews/bestchange.png";
import trustpilot_com from "../../assets/images/reviews/trustpilot_com.png";
import scanbit from "../../assets/images/reviews/scanbit.png";

const ReviewsFromInternet = () => {

  const SampleNextArrow = () => {
    return <span className="icon-chevron-right" />;
  };

  const SamplePrevArrow = () => {
    return <span className="icon-chevron-left" />;
  };

  const { t } = useTranslation("reviews");

  const items = [
    <ReviewsFromInternetItem
      link={t("internetReviewLinks.bestChangeLink")}
      image={bestchange}
      alt="Bestchange"
    />,
    <ReviewsFromInternetItem
      link="https://www.trustpilot.com/review/coin24.com.ua"
      image={trustpilot_com}
      alt="Trustpilot"
    />,
    // <ReviewsFromInternetItem
    //   link="https://obmify.com/coin24-exchange"
    //   image={obmify}
    //   alt="Obmify"
    // />,
    <ReviewsFromInternetItem
      link="https://scanbit.com.ua/ua/exchangers/coin24/"
      image={scanbit}
      alt="Scanbit"
    />,
    // <ReviewsFromInternetItem
    //   link="https://www.otzyvua.net/coin24comua"
    //   image={otzyvua_net}
    //   alt="OtzyvUA"
    // />,
    // <ReviewsFromInternetItem
    //   link="https://glazok.org/exchange/?details=868"
    //   image={glazok_org}
    //   alt="Glazok"
    // />,
    // <ReviewsFromInternetItem
    //   link="https://www.mywot.com/scorecard/coin24.com.ua"
    //   image={mywot_com}
    //   alt="WOT"
    // />,
    // <ReviewsFromInternetItem
    //   link={t("internetReviewLinks.okChangerLink")}
    //   image={okchanger_ru}
    //   alt="OKChanger"
    // />,
    // <ReviewsFromInternetItem
    //   link="https://searchengines.guru/ru/forum/1029944"
    //   image={searchengines_guru}
    //   alt="Searchengines.guru"
    // />,
    // <ReviewsFromInternetItem
    //   link="https://cryptobrokers.ru/coin24-info/"
    //   image={cryptobrokers}
    //   alt="Cryptobrokers"
    // />,
    // <ReviewsFromInternetItem
    //   link="https://001.ae/monitoring/exchanger/coin24"
    //   image={oo1AE}
    //   alt="001.ae"
    // />,
    /*Погана якість Оля (Маркетинг) сказала поки не виводити його*/
    // <ReviewsFromInternetItem
    //   link="https://multirates.org/exchangers/coin24-com-ua"
    //   image={multiRates}
    // />,
    // <ReviewsFromInternetItem
    //   link="https://e-mon.ru/exchanger/753"
    //   image={eMon}
    //   alt="E-mon"
    // />,
    // <ReviewsFromInternetItem
    //   link="https://bits.media/exchanger/coin24-io/"
    //   image={bits_media}
    //   alt="Bits.media"
    // />,
    // <ReviewsFromInternetItem
    //   link="https://mmgp.com/threads/coin24-io-obmen-kriptovaljut.681041/"
    //   image={mmgp_com}
    //   alt="MMGP"
    // />,
    // <ReviewsFromInternetItem
    //   link="https://mmgp.ru/showthread.php?t=706174&highlight=coin24.io"
    //   image={mmgp_ru}
    //   alt="MMGP.ru"
    // />,
    // <ReviewsFromInternetItem
    //   link="https://kurs.expert/ru/obmennik/coin24-com-ua/feedbacks.html"
    //   image={kurs_expert}
    //   alt="Kurs.expert"
    // />,
    // <ReviewsFromInternetItem
    //   link="https://trustorg.com/site/coin24.com.ua"
    //   image={trustorg_com}
    //   alt="Trustorg"
    // />,
    // <ReviewsFromInternetItem
    //   link="https://virtuozi.com/threads/coin24-io-vygodnyj-obmen-kriptovaljut.539040/"
    //   image={virtuozi_com}
    //   alt="Virtuozi"
    // />,
    // <ReviewsFromInternetItem
    //   link="https://webproverka.com/domain.php?coin24.io"
    //   image={webproverka_com}
    //   alt="Webproverka"
    // />
  ];

  const responsive = {
    0: {
      items: 1
    },
    768: {
      items: 2
    },
    992: {
      items: 4
    }
  };

  return (
    <StyledReviewsInternet className="reviews-internet">
      <div className="reviews-internet-content">
        <AliceCarousel
          responsive={responsive}
          mouseTracking
          items={items}
          renderNextButton={SampleNextArrow}
          renderPrevButton={SamplePrevArrow}
        />
      </div>
    </StyledReviewsInternet>
  );
};

export default ReviewsFromInternet;